import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {AuthService, LockoutService} from 'auth-commons';
import {APP_CONFIG_TOKEN, AppConfig} from './app.config';
import {Scope} from 'smag-commons/dto/api';

@Injectable()
export class EMSScopeGuard implements CanActivate {

    constructor(@Inject(APP_CONFIG_TOKEN) private readonly cfg: AppConfig,
                private readonly authService: AuthService,
                private readonly lockout: LockoutService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const obsCan = this.authService.profile.scopes?.includes(Scope.EMS);
        if (!obsCan) {
            this.exit();
            return false;
        }
        return true;
    }

    exit() {
        this.lockout.lockout();
    }
}
